import { Link } from '@chakra-ui/react';

type Props = { text: string; href: string };

export const HeaderLink = ({ text, href }: Props) => {
  return (
    <Link
      fontSize={'14px'}
      href={href}
      color={text !== 'Faucet' ? 'grey' : 'textColor.100'}
      _hover={{ color: 'green.100', textDecoration: 'underline' }}
    >
      {text}
    </Link>
  );
};
